export enum EInternalLinks {
	LINKEDIN = 'https://linkedin.com/company/affilead/',
	PRIVACY = 'https://affilead.ru/privacy/',
	PUBLIC = 'https://affilead.ru/',
	TERMS_OF_USE = 'https://affilead.ru/terms-of-use/',
	HELP = 'https://support.admitad.ru/knowledge-base/articles/Affilead',
	API_INSTRUCTION = 'https://api.affilead.ru/docs/swagger/',
}
